// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementReportBuilder2ReportsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      app_group_id: string,
      email_to: arrayOf(string),
      tags: arrayOf(
        objectOf({
          id: string,
          name: string,
        })
      ),
      report_run_time: number,
      status: string,
      developer_id: string,
      developer_name: string,
      last_edited_by_id: string,
      last_edited_by_name: string,
      marked_as_deleted: boolean,
      edited_at: number,
      created_at: number,
      updated_at: number,
    })
  ),
});
